import React, { useState, useEffect } from 'react';
import { faCertificate } from '@fortawesome/free-solid-svg-icons';
import { Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//Components
import MainCard from '../../components/MainCard/MainCard';
import TextField from '../../components/TextField/TextField';
import Loading from 'components/Loading/Loading';

//Api
import certificado_api from '../../api/certificado_api';
import assinatura_api from '../../api/assinatura_api';
import transportador_api from '../../api/transportador_api';
import destino_api from '../../api/destino_api';

//Helpers
import { showMessage } from '../../helpers/message';
import { validarCampos, objCampo } from '../../helpers/ValidadorDeCampos';

//Estado inicial dos dados do certificado selecionado
function initialStateCertificado() {
    return {
        tipo: "",
        assinaturaId: null,
        assinaturaId_selected: null,
        transportadorId: null,
        transportadorId_selected: null,
        destinoId: null,
        destinoId_selected: null,
        certificadoId: null,
        certificadoId_selected: null,
    };
}
export default function EmissaoCertificados() {
    //Variavel de navegação
    const navigate = useNavigate();

    //Estado que guarda os erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Estado de controle dos dados do certificado selecionado
    const [certificado, setCertificado] = useState(initialStateCertificado());

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle das options das options do tipo
    const [optionsTipo, setOptionsTipo] = useState([]);

    //Estado de controle das options das assinaturas
    const [optionsAssinaturas, setOptionsAssinaturas] = useState([]);

    //Estado de controle nas options do transportador
    const [optionsTransportadores, setOptionsTransportadores] = useState([]);

    //Estado de controle nas options do destino
    const [optionsDestinos, setOptionsDestinos] = useState([]);

    //Estado que guarda a lista de certificados disponivies
    const [optionsCertificados, setOptionsCertificados] = useState([]);

    const [campos, setCampos] = useState([]);

    //Carrega todos os tipos de certificado para emitir
    const loadTiposCertificados = () => {
        setLoading(true);
        certificado_api.GetListTipoDocumento().then(response => {
            response.data = response.data.map(v => { return { value: v, text: v } });
            response.data.unshift({ text: "Selecione", value: "" })
            setOptionsTipo(response.data)
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Carrega as assinaturas disponiveis
    const loadAssinaturas = () => {
        setLoading(true);
        assinatura_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.nome }
            })
            setOptionsAssinaturas(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Carrega as assinaturas disponiveis
    const loadTransportadores = () => {
        setLoading(true);
        transportador_api.GetListDisponiveis().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.fantasia };
            })
            setOptionsTransportadores(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Carrega os destinos disponiveis
    const loadDestinos = () => {
        setLoading(true);
        destino_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.fantasia };
            })
            setOptionsDestinos(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Carrega os certificados de acordo com o tipo selecionado
    const loadCertificados = (tipoDocumento) => {
        certificado_api.GetList(tipoDocumento).then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.identificacao };
            })
            setOptionsCertificados(response.data);
        }).catch(e => showMessage("Aviso", e.message, 'error', null));
    }

    //Change para o select de tipo de certificado
    const onChangeTipo = (e) => {
        const { name, value } = e.target;
        if (value !== "") {
            loadCertificados(value);
            setCertificado({
                ...certificado,
                [name]: value,
                transportadorId: null,
                transportadorId_selected: null,
                destinoId: null,
                destinoId_selected: null,
                certificadoId: null,
                certificadoId_selected: null
            });
        } else {
            setCertificado(initialStateCertificado());
        }
    }

    //Change para os selects de assinatura, transportador e certificados
    const onChangeSearchableSelects = (e, select) => {
        const { name } = select;
        setCertificado({
            ...certificado,
            [name]: e,
            [name.split("_")[0]]: e.value
        })
    }

    //Ação executada ao clicar em emitir certificado
    const onClickEmitirCertificado = () => {
        const _errors = validarCampos(certificado, campos);
        setErrors(_errors[0]);
        console.log(_errors)
        if (_errors[1].length > 0) {
            return;
        }
        setLoading(true);

        if (certificado.tipo === "Certificado Destino") {
            certificado_api.EmitirCertificadoDestino(certificado).then(response => {
                navigate("../../empty/relatorio/EmitirCertificado", { state: { certificado: response.data, pdf: true } })
            }).catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));
        } else {
            certificado_api.EmitirCertificadoTransportador(certificado).then(response => {
                navigate("../../empty/relatorio/EmitirCertificado", { state: { certificado: response.data, pdf: true } })
            }).catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }

    //Carrega os tipos de certificados as assinaturas e os transportadores
    useEffect(() => {
        loadTiposCertificados();
        loadAssinaturas();
        loadTransportadores();
        loadDestinos();
    }, []);

    useEffect(() => {
        const _campos = [
            objCampo({ name: "tipo", required: true }),
            objCampo({ name: "assinaturaId_selected", required: true }),
            objCampo({ name: "certificadoId_selected", required: true }),
        ];

        if (certificado?.tipo === "Certificado Destino") {
            _campos.push(objCampo({ name: "destinoId_selected", required: true }));
        } else {
            _campos.push(objCampo({ name: "transportadorId_selected", required: true }));
        }
        setCampos(_campos);
    }, [certificado.tipo]);

    return (
        <MainCard title={"Emissão de certificados"} btnClick="Emitir Certificado" icon={faCertificate} onClick={onClickEmitirCertificado}>
            {loading && <Loading />}
            <Row>
                <Col md={"12"} lg={"6"}>
                    <TextField name="tipo" label={"* Tipo de certificado"} onChange={onChangeTipo} value={certificado.tipo} type="select" options={optionsTipo} invalid={errors.tipo ? true : false} />
                </Col>
                <Col md={"12"} lg={"6"}>
                    <TextField name="certificadoId_selected" value={certificado.certificadoId_selected} label={"* Certificado"} type="select" searchable onChange={onChangeSearchableSelects} options={optionsCertificados} invalid={errors.certificadoId_selected ? true : false} />
                </Col>
            </Row>
            <Row>
                <Col md={"12"} lg={"6"}>
                    <TextField name="assinaturaId_selected" value={certificado.assinaturaId_selected} label={"* Assinatura"} type="select" options={optionsAssinaturas} onChange={onChangeSearchableSelects} searchable invalid={errors.assinaturaId_selected ? true : false} />
                </Col>
                <Col md={"12"} lg={"6"}>
                    {certificado.tipo === "Certificado Destino" ?
                        <TextField name="destinoId_selected" value={certificado.destinoId_selected} label={"* Destino"} type="select" options={optionsDestinos} onChange={onChangeSearchableSelects} searchable invalid={errors.destinoId_selected ? true : false} />
                        :
                        <TextField name="transportadorId_selected" value={certificado.transportadorId_selected} label={"* Transportador"} type="select" options={optionsTransportadores} onChange={onChangeSearchableSelects} searchable invalid={errors.transportadorId_selected ? true : false} />
                    }
                </Col>
            </Row>
        </MainCard>
    )
}

